import View from './View';

export { default as View, getThemeScreenStyles } from './View';

export default View;
